import { Header1, Header2 } from '@flatsy/core/MaterialUi/Typo'
import React from 'react'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import { useMobile } from 'src/hooks/Mobile'
import UiStatus from '@flatsy/core/Ui/Status'
import { getApplicationBookingStatusProps } from '@flatsy/core/Ui/Status/Utils'
import {
  ApplicationBookingState,
  FrontApplicationBookingState,
} from '@flatsy/types/Applications/BookingStatus'
import { DateTime } from '@flatsy/utils/dates'
import i18n from '@flatsy/utils/translations'
import { DateStatusProps } from './Type'
import { useStyles } from './Style'

const DateStatus: React.FC<DateStatusProps> = ({ application }): React.ReactElement => {
  const classes = useStyles()
  const isMobile = useMobile()
  const { booking } = useApplicationBooking({ applicationId: application.id })

  if (
    application.computedBookingState === FrontApplicationBookingState.CANCELLED ||
    application.computedBookingState === FrontApplicationBookingState.RESCHEDULED
  ) {
    return <></>
  }

  const renderDate = () => {
    if (booking && booking.start_date && booking.start_time) {
      const dateDisplay = i18n.t('@date_at', {
        value: DateTime.fromISO(`${booking.start_date}T${booking.start_time}`),
      })

      return isMobile ? (
        <Header2 lowerCase className={classes.darkBlue}>
          {dateDisplay}
        </Header2>
      ) : (
        <Header1 className={classes.darkBlue} lowerCase>
          {dateDisplay}
        </Header1>
      )
    }
  }

  if (
    application.booking_state === ApplicationBookingState.UNAUTHORIZED ||
    application.booking_state === ApplicationBookingState.AUTHORIZED
  ) {
    return <></>
  }

  return (
    <div className={classes.card}>
      <Header2 lowerCase>{i18n.t('when')}</Header2>
      <div className={classes.cardText}>
        {renderDate()}
        <UiStatus
          {...getApplicationBookingStatusProps({
            state: application?.computedState,
            bookingState: application?.computedBookingState,
          })}
        />
      </div>
    </div>
  )
}

export default DateStatus
